import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from 'src/app/services/i18n.service';
import { NewsletterService } from 'src/app/services/newsletter.service';
import { NewsletterState } from 'src/app/models/newsletter';

// Lien « se désinscrire » présent dans chaque e-mail : sans connexion, liste par liste ou tout d'un coup
@Component({
    selector: 'app-newsletter-unsubscribe',
    templateUrl: './newsletter-unsubscribe.component.html',
    styleUrls: ['./newsletter-pages.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsletterUnsubscribeComponent implements OnInit {

  loading = true;
  saving = false;
  done = false;
  state: (NewsletterState & { email: string }) | null = null;
  error = '';
  private token = '';

  private i18n = inject(I18nService);

  constructor(private route: ActivatedRoute, private newsletterService: NewsletterService) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';
    this.newsletterService.unsubscribeState(this.token).subscribe({
      next: state => {
        this.loading = false;
        this.state = state;
      },
      error: err => {
        this.loading = false;
        this.error = err || this.i18n.t('newsletter.unsubscribeInvalid');
      }
    });
  }

  unsubscribe(choice: { all?: boolean; newsletter?: boolean; partnerOffers?: boolean }): void {
    this.saving = true;
    this.newsletterService.unsubscribe(this.token, choice).subscribe({
      next: state => {
        this.saving = false;
        this.state = state;
        this.done = true;
      },
      error: err => {
        this.saving = false;
        this.error = err || this.i18n.t('common.errorOccurred');
      }
    });
  }
}
